import { TravelRequestHistoryRecord } from 'api/travel-request-detail';
import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ApprovalStatus } from 'model/business-enums';

@customElement('approval-history-table')
export class ApprovalHistoryTableCustomElement {
  @bindable history: TravelRequestHistoryRecord[];

  historyChanged() {
    if (this.history != null) this.history.forEach(record => {
      record['approvalStatusClass'] = record.approvalStatus != null ? `--${ApprovalStatus[record.approvalStatus.value].toLowerCase()}` : null;
      record['requestStatusClass'] = `--${ApprovalStatus[record.requestStatus.value].toLowerCase()}`;
    });
  }
}
